import { RedirectError } from '@shared/constants/error'
import { getToken } from '@shared/util/cookie'
import type { RouteLocationNormalized } from 'vue-router'
import { useUserStore } from '@/store/user'
import { SCHOOL_USER_ROLE, USER_ROLE } from '@/constants'
import { useProcedureLabelStore } from '@/store/procedureLabel'

export const validToken = (to: RouteLocationNormalized) => {
  if (!to.meta.requiresAuth) {
    return Promise.resolve()
  }
  return getToken() ? Promise.resolve() : Promise.reject(new Error('token invalid'))
}

export const validModule = (to: RouteLocationNormalized) => {
  if (!to.meta.requiresAuth || !(to.meta.roleManager || to.meta.roleStudent)) {
    return Promise.resolve()
  }
  const user = useUserStore()
  return user.getUserModuleInfo(to.meta.roleManager ? USER_ROLE.teacher : USER_ROLE.student).then(() => {
    if (!(to.meta.modulePath || []).every(id => to.meta.roleStudent || user.hasTeacherModule(id))) {
      throw new RedirectError({
        name: 'moduleRootRoute',
        params: { ...to.params },
      })
    }
  })
}

export const validUser = (to: RouteLocationNormalized) => {
  if (!to.meta.requiresAuth || !(to.meta.roleManager || to.meta.roleStudent)) {
    return Promise.resolve()
  }
  return useUserStore().getUserInfo().then((res) => {
    if (res.data?.userSchools) {
      const schoolSymbol = to?.params['symbol'] as string
      const toRole = to.meta.roleStudent ? SCHOOL_USER_ROLE.student : SCHOOL_USER_ROLE.teacher
      const school = res.data?.userSchools?.find(item => item.userRole === toRole
         && (!schoolSymbol || item.symbol === schoolSymbol))
      if (school) {
        useUserStore().changeSchool(school.id!)
        return Promise.resolve()
      }
    }
    return Promise.reject(new Error('school invalid'))
  })
}

